<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='" background-image: url(\"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/pngtree-herbal-plants-cosmetic-natural-plant-png-image_4904305.png\");"' class="h-100 bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="pt-5 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container text-center bg-white p-5 rounded " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"\n  background: -webkit-linear-gradient(#23A9B3, #03045e);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;"' class="text-center my-5" >
                <template #default>مزاج شما گرم و خشک(صفراوی)است.   </template>
                </m-h1><m-audio v-bind='{...{"audio":"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/safra.mp3"},...{}}' :style='""' class="col-8 my-4" ></m-audio><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ویژگیهای ذیل مربوط به مزاج سرشتی افراد صفراوی می باشد.

این افراد لاغر اندام هستند  اما مفاصل واستخوان بندی درشت و برجسته دارند. پوست گرم وخشکی دارند. رنگ پوست و سفیدی چشم آنها کمی به زردی می زند. موهای پر پشت و سیاه و گاهی مجعد دارند و به علت حرارت و خشکی زیاد بیشتر مستعد تاسی سرند.
خشکی دهان و عطش فراوان دارند. خیلی گرمایی هستند و در تابستان اذیت می شوند. استعداد این را دارند که با خوردن خوراکیهای خیلی گرم دچار خارش و کهیر شوند. تمایل به خوردن ترشی ها (سرکه، تمرهندی و لواشک) را دارند و هم چنین سردیهایی مثل خیار، کاهو و هندوانه. تمایل به خوردن شیرینی در اینها کم است. نبض پر و قوی دارند. عروق برجسته در دست دارند. این افراد زود عصبانی شده و زود هم عصبانیتشان فروکش می کند. بسیار پر انرژی و پر تحرک هستند. افراد باهوش و زیرک هستند و هم چنین پر حرف. در کارها چالاک و سریع هستند. افراد دقیق، منظم و تیز بین هستند. میل بالای جنسی و توان جنسی متغیر دارند.
پیوسته، سریع و بلند صحبت می کنند. خوابشان کم و سبک است. قدرت هاضمه آن ها خوب است و معمولاً یبوست دارند.
از حافظه و قدرت یادگیر ی بالایی برخوردار هستند،  روابط اجتماعی آن ها قوی است. عجول و بی قرارند.
اصولاً مزاج های گرم (دموی ها و صفراوی ها)  از لحاظ اعمال بدنی و خصوصیات حیاتی از قدر ت بالایی برخوردارند، گرما موجب افزایش کارکرد اعضای مختلف از مغز و اعصاب گرفته تا اندام های تناسلی می گردد.

توصیه و تدابیر:
رژيم غذايي مناسب براي صفراوي‌ها (گرم و خشك) غذاهائي است كه سرد و تر باشند.
افراد صفراوي غالباً در اثر حجامت تعديل مزاج يافته و رنگ و رويي به مراتب روشن‌تر از قبل خواهند داشت، اشتهاي آنان با حجامت افزايش مي‌يابد و در صورت تكرار حجامت فربه و چاق خواهند شد. نمونه‌اي از رژيم غذايي مناسب براي افراد صفراوي كاهوست كه سرد و تر است و براي دفع صفرا مفيد است. ماهي، ماست و به طور كلي لبنيات، مركبات، ماء الشعير (آب جو) آب‌غوره ، آب ‌ليمو براي صفراوي‌ها مفيد و لازم است.
t.me/AlisinaTebeIrani

علائم  غلبه صفرا:
اگر تعادل میان اخلاط و مقدار آنها یا کیفیت هر یک از اخلاط بهم بخورد، موجب بیماری در بدن می شود یا به عبارتی موجب غلبه یک خلط بر اخلاط دیگر در بدن می شود که می بایست مورد درمان قرار گیرد که در ذیل علایم غلبه خلط صفرا ذکر شده است.
•    زردی رنگ چشم و پوست
•    خشکی دهان وبینی
•    عطش زیاد
•    جوش و آکنه در سر وصورت
•    خشکی پوست واگزما
•    تلخی دهان
•    کاهش اشتها به غذا
•    احساس گز گز و سوزن سوزن شدن بدن
•    نبض سریع
•    احساس تهوع
   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mAudio from '@moeinmdn/miw-alpha-components/src/package/Tags/Audio'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mAudio,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
